import React, { useContext } from 'react'
import { TransactionDto } from 'api/Transaction/Types/Transaction'
import { successToast, ToastContext } from 'components/Toast/Toast'
import { useApiClient } from 'utils/api/ApiClient'
import { WalletsApiClient } from 'utils/api/walletsApiClient'

import { TransactionReverseFormValues } from './TransactionReverseForm'
import { TransactionReverseIBCommissionForm } from './TransactionReverseIBCommissionForm'

interface Props {
  transaction: TransactionDto

  onClose(): void
}
export const TransactionReverseIBCommissionPage: React.FC<Props> = (props) => {
  const setToast = useContext(ToastContext)
  const walletsApiClient = useApiClient(WalletsApiClient)

  const onSubmit = async (values: TransactionReverseFormValues) => {
    await walletsApiClient.reverseCompletedTransaction({
      transactionId: props.transaction.id,
      comment: values.comment,
    })
    setToast(successToast('Transaction reversed.'))
    props.onClose()
  }

  return <TransactionReverseIBCommissionForm transaction={props.transaction} onSubmit={onSubmit} />
}
